import React from "react";
import { PageCover } from "../../common/PageCover";

export const VisualisationCover = () => {
  return (
    <PageCover
      src="/img/visualisation1.jpg"
      backText="VISUALIZATIONS"
      frontText="PORTFOLIO"
      description="3D renderings are a photorealistic way of understanding
      an architectural plan, a construction drawing or something that does
      not exist yet, an idea or a concept."
    />
  );
};
